import parseHTML from "../lib/dom/funciones/parse_html";

const bloqueaTabulador = (menu: HTMLElement, enlaces: HTMLElement[]) => {
    const detectorFocoInicio = parseHTML('<div tabindex="0"></div>'),
        detectorFocoFin = parseHTML('<div tabindex="0"></div>');

    menu.insertBefore(detectorFocoInicio, menu.firstChild);
    detectorFocoInicio.addEventListener('focus', () => enlaces[enlaces.length - 1].focus());

    menu.appendChild(detectorFocoFin);
    detectorFocoFin.addEventListener('focus', () => enlaces[0].focus());
}

const configuraAperturaYCierre = (menu: HTMLElement, enlaces: HTMLElement[]) => {
    const abrir = document.getElementById('menu-abrir') as HTMLButtonElement,
        cerrar = document.getElementById('menu-cerrar') as HTMLButtonElement,
        quita = (ev: TransitionEvent) => (ev.target as HTMLElement).remove(),
        padre = menu.parentElement as HTMLElement;

    menu.addEventListener('keydown', (ev: KeyboardEvent) => {
        if (ev.key === 'Escape') {
            cerrar.click();
        }
    });

    menu.remove();

    abrir.addEventListener('click', () => {
        padre.appendChild(menu);
        setTimeout(() => {
            menu.removeEventListener('transitionend', quita);
            abrir.setAttribute('aria-expanded', 'true');
            cerrar.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-hidden', 'false');
            menu.removeAttribute('inert');
            enlaces[1].focus();
        });
    });

    cerrar.addEventListener('click', () => {
        cerrar.setAttribute('aria-expanded', 'true');
        abrir.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        abrir.focus();
        menu.setAttribute('inert', '');
        menu.addEventListener('transitionend', quita);
    });

    enlaces
        .filter(x => {
            const href = x.getAttribute('href') || '';
            return href.indexOf('#') > -1 && !href.startsWith('http');
        })
        .forEach(x => x.addEventListener('click', () => cerrar.click()));
}

const configuraDesplegables = (menu: HTMLElement, unico: boolean) => {
    const conHijos = [].slice.call(menu.querySelectorAll('.menu-item-has-children')) as HTMLAnchorElement[];

    if (conHijos.length === 0) {
        return;
    }

    const oculta = (ev: TransitionEvent) => (ev.target as HTMLElement).hidden = true,
        abre = (menuItem: HTMLElement) => {
            const boton = menuItem.querySelector('button') as HTMLButtonElement,
                subMenu = menuItem.querySelector('.sub-menu') as HTMLUListElement;

            boton.setAttribute('aria-pressed', 'true');
            subMenu.hidden = false;
            subMenu.style.height = subMenu.scrollHeight + 'px';
            subMenu.removeEventListener('transitionend', oculta);
        },
        cierra = (menuItem: HTMLElement) => {
            const boton = menuItem.querySelector('button') as HTMLButtonElement,
                subMenu = menuItem.querySelector('.sub-menu') as HTMLUListElement;

            boton.setAttribute('aria-pressed', 'false');
            subMenu.style.height = '0';
            subMenu.addEventListener('transitionend', oculta, {once: true});
        };

    conHijos.forEach((menuItem, i) => {
        const enlace = menuItem.querySelector('a') as HTMLAnchorElement,
            subMenu = menuItem.querySelector('.sub-menu') as HTMLUListElement,
            agrupado = parseHTML<HTMLDivElement>(`<div class="menu__enlace"></div>`),
            boton = parseHTML<HTMLButtonElement>(`<button aria-controls="sub-menu-${i}" aria-pressed="false" role="button" class="menu__desplegar">
        <svg viewBox="0 0 10 5" width="20" height="10"><path d="M2 1L5 4L8 1" stroke="currentColor" fill="none" /></svg>    
    </button>`),
            cambia = (e: UIEvent) => {
                e.preventDefault();

                let estamosAbriendo = boton.getAttribute('aria-pressed') === 'false';

                if (estamosAbriendo && unico) {
                    conHijos
                        .filter(x => x.querySelector('button'))
                        .forEach(cierra);
                }

                estamosAbriendo ? abre(menuItem) : cierra(menuItem);
            };

        enlace.parentNode!.replaceChild(agrupado, enlace);
        agrupado.appendChild(enlace);
        agrupado.appendChild(new Text(' '));
        agrupado.appendChild(boton);

        subMenu.setAttribute('id', `sub-menu-${i}`);
        subMenu.style.height = '0';
        subMenu.hidden = true;

        boton.addEventListener('click', cambia);
        boton.setAttribute('aria-controls', subMenu.id);
    });
}

const configuraActualizacionDeAltura = () => {
    let ultimaAltura = -1,
        ultimoScroll = -1;

    const cabecera = document.querySelector('.cabeceraPrincipal') as HTMLElement,
        actualiza = () => {
            if (cabecera.offsetHeight !== ultimaAltura) {
                ultimaAltura = cabecera.offsetHeight;
                document.documentElement.style.setProperty('--altura-cabecera', ultimaAltura + 'px');
            }

            if (window.scrollY !== ultimoScroll) {
                ultimoScroll = window.scrollY;
                document.documentElement.style.setProperty('--scroll', ultimoScroll + 'px');
            }

            requestAnimationFrame(actualiza);
        }

    requestAnimationFrame(actualiza);
};

const menu = (unico: boolean = true) => {
    const menu = document.getElementById('menu') as HTMLDivElement,
        enlaces = [].slice.call(menu.querySelectorAll('a, button')) as HTMLAnchorElement[];

    bloqueaTabulador(menu, enlaces);
    configuraAperturaYCierre(menu, enlaces);
    configuraDesplegables(menu, unico);
    configuraActualizacionDeAltura();
};

export default menu;